import { OrgConfigPage } from '@hq/org-admin';
import { hq } from '../session';

/**
 * 机构参数（平台侧跨租户，门禁 sys:config:manage）。
 * 页面实现收敛在 `@hq/org-admin`，本端开启租户维度（先选租户再选机构）。
 */
export default function OrgConfig() {
  return <OrgConfigPage platform hq={hq} />;
}
